import React from 'react'
import classes from './Toolbar.css';
import Logo from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import ToggleDrawer from './ToggleDrawer/ToggleDrawer';


const toolbar=(props)=>{
    return <header className={classes.Toolbar}>
        <ToggleDrawer openDrawer={props.openDrawer} />
        <Logo/>
        <nav className={classes.DesktopOnly}>
            <NavigationItems isAuthenticated={props.isAuthenticated} ></NavigationItems>
        </nav>
    </header>
}

export default toolbar;